var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFilterArrows = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M205.774 158.348c16.342 0 24.526 19.76 12.97 31.315l-65.775 65.775c-7.164 7.164-18.778 7.164-25.941 0l-65.776-65.775c-11.556-11.556-3.371-31.315 12.97-31.315zM152.968 24.563l65.776 65.776c11.555 11.556 3.371 31.314-12.97 31.314H74.221c-16.342 0-24.526-19.758-12.97-31.314l65.775-65.776c7.163-7.163 18.778-7.163 25.941 0"
})));
export default SvgFilterArrows;